export enum BatteryLevels {
    None = 5,
    Critical = 10,
    Low = 30,
}
